import { ApolloError, useQuery } from "@apollo/react-hooks";
import { DocumentNode } from "graphql";
import { MY_HR_GET_FILTERED_LIST_COUNT } from "my-hr/graphql";

export interface UseMyHrFilteredListCountParams {
  roleFilters?: string[];
  isActive?: boolean;
  withNoUsers?: boolean;
  useOrLogic?: boolean;
}

export interface UseMyHrFilteredListCountResult {
  data: number;
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

interface FilteredListCountQueryData {
  filteredListCount: number;
}

interface FilteredListCountQueryVars {
  roleFilters?: string[];
  isActive?: boolean;
  withNoUsers?: boolean;
  useOrLogic?: boolean;
}

/**
 * Hook to fetch the count of HR list entries matching the given filters.
 */
export const useMyHrFilteredListCount = ({
  roleFilters,
  isActive,
  withNoUsers,
  useOrLogic,
}: UseMyHrFilteredListCountParams): UseMyHrFilteredListCountResult => {
  const { data, loading, error, refetch } = useQuery<
    FilteredListCountQueryData,
    FilteredListCountQueryVars
  >(MY_HR_GET_FILTERED_LIST_COUNT as DocumentNode, {
    fetchPolicy: "cache-and-network",
    variables: { roleFilters, isActive, withNoUsers, useOrLogic },
  });

  const refetchVoid = () => {
    void refetch();
  };

  return {
    data: data?.filteredListCount ?? 0,
    loading,
    error,
    refetch: refetchVoid,
  };
};

export default useMyHrFilteredListCount;
